let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("deU0o")).then(() => parcelRequire('9Kb0h'));